import React from 'react';

const MarketingCard = ({ card }) => {
  const getColorScheme = (color) => {
    switch (color) {
      case 'White':
        return 'color-scheme-1';
      case 'Black':
        return 'color-scheme-2';
      case 'Period':
        return 'color-scheme-3';
      case 'Bladder':
        return 'color-scheme-4';
      case 'Teens':
        return 'color-scheme-5';
      default:
        return 'color-scheme-6';
    }
  };
  if (!card) return null;

  const Card = () => {
    return (
      <div className={`relative flex flex-col overflow-hidden rounded-lg+ ${getColorScheme(card.scheme)}`}>
        <div className="aspect-[321/270]">
          {card.image && (
            <img
              src={card.image}
              alt={card.title}
              className="size-full object-cover object-top"
            />
          )}
        </div>
        <div className={`flex min-h-[129px] flex-col justify-start rounded-b-lg+ px-5 py-6`}>
          {card.title && <p className="heading-4">{card.title}</p>}
          {card.description && <p className="body-2 mt-1">{card.description}</p>}
        </div>
      </div>
    );
  };

  if (card?.url) {
    return (
      <a href={card.url}>
        <Card />
      </a>
    );
  }
  return (
    <article className="marketing-card">
      <Card />
    </article>
  );
};

export default MarketingCard;
